import React from 'react';
import { ControlLabel, FormControl, FormGroup, HelpBlock, InputGroup } from 'react-bootstrap';
import NumberFormat from 'react-number-format';

const CalculatorQuestion = React.forwardRef(({ id, label, help, validationState, changeHandler, ...props }, ref) => {
  let addOn;
  if (props.type === "money") {
    props.type = "number";
    addOn = <InputGroup.Addon><i className="fa fa-dollar" /></InputGroup.Addon>;
  }

  delete props.type;
  
  let input = <NumberFormat thousandSeparator customInput={FormControl} inputRef={ref} onChange={(e) => changeHandler(e.target.value)} {...props} />;

  if (addOn) {
    input = (
      <InputGroup>
        {addOn}
        {input}
        <FormControl.Feedback />
      </InputGroup>
    );
  }

  return (
    <FormGroup controlId={id} className="calculator-question" validationState={validationState}>
      <ControlLabel>{label}</ControlLabel>
      {input}
      {!addOn && <FormControl.Feedback />}
      {help && <HelpBlock>{help}</HelpBlock>}
    </FormGroup>
  );
});

export default CalculatorQuestion;


// WEBPACK FOOTER //
// ./src/Components/roi-calculator/CalculatorQuestion.jsx